import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Currency from 'components/Currency';
import { RootStyle, MainStyle } from 'theme/layouts';
import DashboardNavbar from './Navbar';
import DashboardSidebar from './Sidebar';
import { Box, useTheme } from '@mui/material';
import LockScreen from './LockScreen';
import { SystemMessageModal } from './SystemMessageModal';
import { useAppSelector } from 'hooks/redux.hooks';
import { getShouldShowSystemMessageModal } from 'state/reducers/system-messages.reducer';

export default function DashboardLayout(props: { noCurrency?: boolean; nosidebar?: boolean }) {
  const [open, setOpen] = useState(true);
  const [mobilOpen, setMobilOpen] = useState(false);
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const shouldShowSystemMessageModal = useAppSelector(getShouldShowSystemMessageModal);

  return (
    <RootStyle>
      <CssBaseline />
      {!props.nosidebar && (
        <>
          <Box sx={{ [theme.breakpoints.down('sm')]: { display: 'none' } }}>
            <DashboardSidebar
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              open={open}
              toggleSidebar={() => setOpen(!open)}
            />
          </Box>
          <Box sx={{ [theme.breakpoints.up('sm')]: { display: 'none' } }}>
            <DashboardSidebar
              anchorEl={anchorEl}
              open={mobilOpen}
              setAnchorEl={setAnchorEl}
              mobile={true}
              toggleSidebar={() => setMobilOpen(!mobilOpen)}
            />
          </Box>
        </>
      )}
      <DashboardNavbar
        nosidebar={props.nosidebar}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        open={open}
        toggleSidebar={() => setOpen(!open)}
        toggleMobileSidebar={() => setMobilOpen(!mobilOpen)}
      />
      <MainStyle>
        {shouldShowSystemMessageModal && <SystemMessageModal />}
        <LockScreen />
        {!props.noCurrency && <Currency />}
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
